import {
  Box,
  Divider,
  Grid2,
  Stack,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import React from "react";
import ClaimRowChip from "./ClaimRowChip";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import { useNavigate } from "react-router-dom";
import { useNewMailMode } from "../NewMailModeContext";
import { grey } from "@mui/material/colors";

const thresholdColors = [
  "#b6d8e3",
  "#a9d6e5", //lightest blue
  "#89c2d9", //
  "#61a5c2",
  "#468faf",
  "#2c7da0",
];

function ClaimRow(props) {
  const { item, columnsCount, hover, back_link } = props;
  const current_total_pairs = item.similar_comparisons_list.length;
  const navigate = useNavigate();

  const handleRowClick = () => {
    navigate(`/resultviewer/${item.claim_id}`, {
      state: { item: item, back_link: back_link },
    });
  };


  const borderColor = grey[500];
  return (
    <TableRow
      hover={hover}
      onClick={handleRowClick}
      // component={Link}
      // onClick={() => console.log("Navigating with to details for claim_id:", item.claim_id)} // Log the item
      // to={`/resultviewer/${item.claim_id}`}
      // state={{ item: item, back_link: back_link }}
      sx={{
        textDecoration: "none",
        "& > *": { borderBottom: "unset" },
        cursor: "pointer",
        border: 0,
        borderColor: "gray",
      }}
      colSpan={columnsCount}
    >
      <TableCell
        align="center"
        colSpan={1}
        sx={{
          p: 0,
          py: 1.25,
          fontSize: 16,
          border: 0,
          borderTop: 1,
          borderColor: borderColor,
        }}
      >
        <Stack
          spacing={0.5}
          direction={"row"}
          alignItems={"center"}
          justifyContent={"center"}
        >
          <Typography
            sx={{ fontSize: { xs: 14, sm: 16, md: 18 }, fontWeight: "bold" }}
          >
            {item.claim_id}
          </Typography>
          <Typography sx={{ fontSize: 12, color: "#404040" }}>
            ({item.overall_timespan} days)
          </Typography>
        </Stack>
      </TableCell>
      <TableCell
        align="center"
        colSpan={1}
        sx={{
          p: 0,
          border: 0,
          borderTop: 1,
          borderColor: borderColor,
          fontSize: { xs: 14, sm: 16, md: 18 },
        }}
      >
        {item.num_qualifying_pairs}

      </TableCell>

      <TableCell
        align="center"
        sx={{
          p: 0,
          fontSize: { xs: 14, sm: 16, md: 18 },
          border: 0,
          borderTop: 1,
          borderColor: borderColor,
        }}
      >
        {/* {item.total_tasks.new_mail_to_new_mail} */}
        <Box sx={{ border: 0, justifyContent: "center", display: "flex" }}>
          <ClaimRowChip
            value={current_total_pairs}
            fontSize={12}
            valueSize={18}
            chip_width={80}
            chip_color={thresholdColors[1]}
          />
        </Box>
      </TableCell>
    </TableRow>
  );
}

export default ClaimRow;
